const metrics = {
  desktop: 1120,
  tablet: 768,
  phone: 600,
}

export default {
  colors: {
    black: '#000000',
    white: '#FFFFFF',
    orange: '#FF6C00',
    orange1: '#EB6500',
    petrolBlue: '#007398',
    lightBlue: '#3679E0',
    secondary1: '#FFF0E4',
    secondary2: '#CDE4FF',
    grey4: '#53565A',
    grey3: '#B1B1B1',
    grey2: '#DCDCDD',
    grey1: '#F7F7F7',
    purple4: '#3C1276',
    purple3: '#661CCA',
    purple2: '#BB84FF',
    purple1: '#F5EDFF',
    blue5: '#0C7DBB',
    blue4: '#073973',
    blue3: '#3679E0',
    blue2: '#ACD2FF',
    blue1: '#E9F3FF',
    green5: '#29A61B',
    green4: '#496E01',
    green3: '#8ED700',
    green2: '#C0F25D',
    green1: '#F9FFED',
    brown4: '#976500',
    brown3: '#FDD300',
    brown2: '#FFEC84',
    brown1: '#FFF9DB',
    red5: '#F73E29',
    red4: '#A92B1D',
    red3: '#F73E29',
    red2: '#FEB7B7',
    red1: '#FFECEC',
  },
  metrics,
  breakpoints: [metrics.phone, metrics.tablet, metrics.desktop],
}
